<template>
  <div class="slide" id="will-share" v-show="isVisibleSlide('will-share')">
    <div class="container">
      <h4 v-if="!$store.state.journeys.leave_story">No problem.</h4>
      <h3
        v-if="!$store.state.journeys.leave_story"
      >Every extra signature brings us a little bit closer to changing the law for good.</h3>
      <h2
        v-if="!$store.state.journeys.leave_story"
      >Will you increase your impact by sharing this with your friends now?</h2>
      <h3 v-if="$store.state.journeys.leave_story">Thanks so much - we’ll be in touch soon.</h3>
      <h2
        v-if="$store.state.journeys.leave_story"
      >Finally, could you share our campaign to help get more people on board?</h2>
      <div class="button_wrap">
        <button
          @click="gotoSlide('share'), analytics('will_share', 'yes'), fbq('trackCustom', 'WillShare')"
          class="pink"
        >Yes</button>
        <button
          @click="gotoSlide('donate'), analytics('will_share', 'no'), fbq('trackCustom', 'DonatePage')"
          class="grey"
        >No</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Thanks",
  props: ["gotoSlide", "isVisibleSlide", "analytics"]
};
</script>
<style lang="scss" scoped>
h4 {
  font-weight: normal;
  font-size: 22px;
  margin: 0;
  font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
}
h3 {
  font-size: 22px;
  font-weight: bold;
  font-family: "Sabon", Georgia, Times, "Times New Roman", serif;
}
h2 {
  font-size: 26px;
}
</style>
